var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3334C5.39956 18.3284 1.67156 14.6004 1.6665 10.0001V9.83343C1.75811 5.25387 5.52866 1.60673 10.1087 1.6675C14.6888 1.72827 18.3613 5.47417 18.3313 10.0545C18.3014 14.6349 14.5803 18.3325 9.99984 18.3334ZM9.9865 16.6668H9.99984C13.6804 16.6631 16.6617 13.6774 16.6598 9.99677C16.658 6.31617 13.6738 3.33343 9.99317 3.33343C6.31257 3.33343 3.32835 6.31617 3.3265 9.99677C3.32466 13.6774 6.30591 16.6631 9.9865 16.6668ZM10.8332 15.0001H9.1665V13.3334H10.8332V15.0001ZM10.8332 12.5001H9.1665C9.14017 11.4148 9.70495 10.4008 10.6415 9.85176C11.1915 9.4301 11.6665 9.06676 11.6665 8.33343C11.6665 7.41295 10.9203 6.66676 9.99984 6.66676C9.07936 6.66676 8.33317 7.41295 8.33317 8.33343H6.6665V8.25843C6.6799 7.06754 7.32761 5.97427 8.36565 5.39043C9.40368 4.80659 10.6743 4.82088 11.699 5.42793C12.7236 6.03497 13.3466 7.14254 13.3332 8.33343C13.2735 9.23261 12.7912 10.0503 12.0332 10.5376C11.3479 10.9678 10.9038 11.6941 10.8332 12.5001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.fac13cf993c8fb2167974c338b53799a.svg";
export { ForwardRef as ReactComponent };